module.exports = __webpack_public_path__ + "static/worth-it-98e549b9307b4df15b1353ee6f056b35.gif";